export default __webpack_public_path__ + "static/media/img-1.b5d076b5.jpg";